// extracted by mini-css-extract-plugin
export default {"avatar":"A_ChatAvatar_avatar__6V2Mt","initials":"A_ChatAvatar_initials__1Rcb2"};